// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.0-beta.f47d25a4f',
  revision: 'f47d25a4f',
  branch: 'develop',
  date: 'Thu, 27 Aug 2026 07:59:26 GMT'
};